import { Analysis, PossibleRootCauseCategory } from '.';

export class ProstateAnalysis extends Analysis {
    calculateInsights() {
        
        if (this.ba.psaTotal.isGreaterThanOptimal() && this.ba.bloodwork.client?.gender === 'M')
        {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_17000);
        }

        if (this.ba.psaTotal.isGreaterThanOptimal() && this.ba.bloodwork.client?.gender === 'F')
        {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_17005);
        }

        if (this.ba.psaFree.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_17010);
        }

          if (this.ba.psaFreePercent.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_17015);
        }

    }
}